import type { Role, SignalMessage } from './types';

export interface SignalClient {
  send(msg: SignalMessage): void;
  close(): void;
}

export interface SignalHandlers {
  onMessage(msg: SignalMessage): void;
  onOpen?(): void;
  onClose?(): void;
  onError?(err: Event): void;
}

export function connectSignal(code: string, role: Role, h: SignalHandlers): SignalClient {
  const proto = location.protocol === 'https:' ? 'wss:' : 'ws:';
  const ws = new WebSocket(`${proto}//${location.host}/api/signal/${code}?role=${role}`);
  ws.addEventListener('open', () => h.onOpen?.());
  ws.addEventListener('close', () => h.onClose?.());
  ws.addEventListener('error', (e) => h.onError?.(e));
  ws.addEventListener('message', (ev) => {
    try {
      const msg = JSON.parse(ev.data as string) as SignalMessage;
      h.onMessage(msg);
    } catch {
      /* ignore malformed */
    }
  });
  return {
    send(msg) {
      if (ws.readyState === WebSocket.OPEN) ws.send(JSON.stringify(msg));
    },
    close() {
      try { ws.close(1000); } catch { /* ignore */ }
    },
  };
}

export async function createRoom(): Promise<string> {
  const res = await fetch('/api/room', { method: 'POST' });
  if (!res.ok) throw new Error(`createRoom failed: ${res.status}`);
  const data = (await res.json()) as { code: string };
  return data.code;
}
